import { Component, EventEmitter, Input, Output } from '@angular/core';

import { COLOUR_SLOTS } from '../workspace/map-colours';

/** The eight sub-region outline colours (--app-subregion-1..8) to pick from (#260). Presentational. */
@Component({
  selector: 'div[app-suburb-colour-picker]',
  templateUrl: './suburb-colour-picker.component.html',
  styleUrls: ['./suburb-colour-picker.component.scss'],
})
export class SuburbColourPickerComponent {
  /** The slot in use (1–8). */
  @Input() selected = 0;
  @Input() disabled = false;
  @Output() pick = new EventEmitter<number>();

  readonly slots = COLOUR_SLOTS;
}
